/** @file Structural shape of a puppet node (design 4.1, 18.6); tree rules are checked by validateNodes. */
import { checkArray } from '@zilo/pose3d-format/validate/fields/checkArray';
import { checkBoolean } from '@zilo/pose3d-format/validate/fields/checkBoolean';
import { checkEnum } from '@zilo/pose3d-format/validate/fields/checkEnum';
import { checkNumber } from '@zilo/pose3d-format/validate/fields/checkNumber';
import { checkRecord } from '@zilo/pose3d-format/validate/fields/checkRecord';
import { checkShape } from '@zilo/pose3d-format/validate/fields/checkShape';
import { checkString } from '@zilo/pose3d-format/validate/fields/checkString';
import { checkTuple } from '@zilo/pose3d-format/validate/fields/checkTuple';
import type { Shape } from '@zilo/pose3d-format/validate/fields/fieldCheck';
import { NAME_PATTERN } from '@zilo/pose3d-format/validate/fields/namePattern';

const name = checkString(NAME_PATTERN);
const frameAnim = checkShape({
  required: { frames: checkArray(checkNumber({ int: true, min: 0 }), 1), hold: checkNumber({ int: true, min: 1 }) },
});

/** Shape of `PuppetNode`. */
export const NODE_SHAPE: Shape = {
  required: { pos: checkTuple(3) },
  optional: {
    parent: name, rest: checkTuple(3), mirror: name, ik: checkNumber({ int: true, min: 0 }), flexParent: checkBoolean,
    hidden: checkBoolean, lookAt: checkBoolean, originOffset: checkTuple(3), group: checkEnum([1, 2, 3, 4, 5, 6, 7]),
    frameAnims: checkRecord(frameAnim),
    volume: checkShape({ required: { radius: checkNumber({ min: 0 }), length: checkNumber({ min: 0 }) } }),
  },
};
